<script setup lang="ts">
import type { Article } from "~/types";
import type { PropType } from "vue";
import { getFormattedTimestamp } from "../../utils/common";

const props = defineProps({
  article: {
    type: Object as PropType<Article>,
    required: true,
  },
});

const authorName = computed(() => {
  if (!props.article?.author?.first_name && !props.article?.author?.last_name) {
    return props.article?.author?.username;
  }
  return `${props.article?.author?.first_name} ${props.article?.author?.last_name}`;
});
</script>

<template>
  <NuxtLink
    :to="`/news/${article.slug}`"
    class="cursor-pointer gap-3 rounded p-3 font-['UniSans']"
  >
    <div class="mb-2">
      <img
        v-if="article?.media?.url"
        class="aspect-video w-full rounded object-cover object-center"
        :src="article?.media?.url"
        alt="pokergo-logo"
      />
      <div v-else class="aspect-video w-full bg-surface-950" />
    </div>

    <div class="mb-2 truncate text-xl font-semibold">
      {{ article.title }}
    </div>
    <div class="flex gap-4 text-[#9CA3AF]">
      <div v-if="authorName" class="text-sm">
        <font-awesome-icon :icon="['fas', 'pen']" class="mr-1" />
        {{ authorName }}
      </div>
      <div class="text-sm">
        <font-awesome-icon :icon="['fas', 'calendar']" class="mr-1" />
        {{ getFormattedTimestamp(article.published_at) }}
      </div>
    </div>
  </NuxtLink>
</template>

<style scoped></style>
